import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import PageLoading from '@zenbusiness/zui/PageLoading';

import { DEFAULT_SEGMENT } from '#client/build-env';

export default function Landing() {
  const { authenticated, login } = useAuthentication();
  const { loading: entityLoading, businessEntityUuid } = useBusinessEntity();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authenticated) {
      login(`${DEFAULT_SEGMENT}/`);
      return;
    }
    if (!entityLoading && businessEntityUuid) {
      navigate(`${DEFAULT_SEGMENT}/${businessEntityUuid}/`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, entityLoading, businessEntityUuid]);

  return <PageLoading />;
}
